export const IconLogout: {
  name: 'icon_logout-5e3ec308d26c'
} = {
  name: 'icon_logout-5e3ec308d26c'
}
